import _ from 'underscore';
import React, { useContext } from 'react';
import { mergeClasses } from '@fluentui/react-components';

import { LayoutContext } from './layout-context';
import { Mode } from './mode';
import { ILayoutContext } from './types';
import { useAppLayoutStyles } from './styles';

export interface ILayoutProps {
  item: string;
  component: React.ComponentType<any>;
  [key: string]: any;
}

export const Layout: React.FC<ILayoutProps> = (props: ILayoutProps) => {
  const Component = props.component;
  const itemName = props.item;
  const {
    config, styles, change: changeLayout, isGridLayout, isNavRefreshNew,
  } = useContext<ILayoutContext>(LayoutContext);
  const layoutStyles = useAppLayoutStyles();

  const componentProps = { ...(_.result(config, itemName)), changeLayout };

  let className = '';
  if (!isGridLayout) {
    const { classes } = _.result(styles, itemName);
    className = _.result(classes, itemName);
  }

  const shellClassName = `app-shell-${itemName}`;
  const refreshClassName = isNavRefreshNew ? `app-shell-refresh-${itemName}` : '';

  // Apply additional styles when isNavRefreshNew is true
  let dynamicClassName = `${shellClassName} ${refreshClassName} ${className}`.trim();
  if (isNavRefreshNew) {
    if (itemName === 'topBanner') {
      dynamicClassName = mergeClasses(shellClassName, refreshClassName, className, layoutStyles.topBannerNew);
    } else if (itemName === 'copilot') {
      const isCopilotVisible = componentProps.mode !== Mode.Hidden && componentProps.mode !== Mode.Collapsed;
      dynamicClassName = mergeClasses(
        shellClassName,
        refreshClassName,
        className,
        layoutStyles.copilotNew,
        isCopilotVisible ? layoutStyles.copilotNewPadding : ''
      );
    } else if (itemName === 'tab') {
      // Background color depends on scopePanel and menu state:
      // - Both scopePanel and menu expanded: colorNeutralBackground2
      // - Otherwise (default): colorNeutralBackground5
      const scopePanelConfig = config?.status;
      const menuConfig = config?.menu;
      const isScopePanelExpanded = scopePanelConfig?.mode === 'expanded';
      const isMenuExpanded = menuConfig?.mode === 'expanded';
      const tabStyle = (isScopePanelExpanded && isMenuExpanded)
        ? layoutStyles.tabNewScopePanelExpanded
        : layoutStyles.tabNewScopePanelCollapsed;
      dynamicClassName = mergeClasses(shellClassName, refreshClassName, className, tabStyle);
    } else if (itemName === 'status') {
      dynamicClassName = mergeClasses(shellClassName, refreshClassName, className, layoutStyles.statusNew);
    }
  }

  if (config.status?.inlineStatus) {
    if (itemName === 'status') {
      dynamicClassName = mergeClasses(dynamicClassName, layoutStyles.statusExtended, 'inline-status');
    } else if (itemName === 'menu') {
      dynamicClassName = mergeClasses(dynamicClassName, layoutStyles.menuExtended);
    }
  }

  return (
    <div
      className={dynamicClassName}
      style={isGridLayout && (componentProps.mode === Mode.Hidden) ? { display: 'none' } : {}}
    >
      <Component {..._.defaults(componentProps, props)} />
    </div>
  );
};
